import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { fullSingleTimelineReselector, fullMultiTimelineReselector } from 'src/app/store/reselectors/onsiteTimeline.reselector';
import { DateSchedule } from 'src/app/store/programs.era';
import { takeUntil } from 'rxjs/operators';
import { JoiEvent, LabelMaps, makeEmptyLabelMaps } from 'src/app/store/events.era';
import { loadLocal, saveLocal } from '../../helpers/helpers';
import { performerDisplayTypes, Performer } from 'src/app/store/performers.era';
import { OnsiteProgram, OnsiteSingleTimeline, OnsiteTimelineBrick } from 'globals/store/onsite.data';
import { myScheduleFullSingleTimelineReselector, myScheduleFullMultiTimelineReeselector } from 'src/app/store/reselectors/onsite.myschedule.reselector';
import { Ranking } from 'globals/store/events.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { programSessionsActivitesMegaTagReselector } from '../../store/reselectors/programs.reselector';
import { TagPanelData } from 'globals/store/tags.data';
import { Dictionary } from '@ngrx/entity';
import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { onsiteActions } from 'src/app/store/onsite.era';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { CommonModule, DatePipe } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { ExpandableBarWrapperComponent } from 'src/app/components/wrappers/expandable-bar-wrapper.component';
import { MultiTimelineColumnComponent } from 'src/app/components/timeline/multi-timeline-column.component';
import { TimelineComponent } from 'src/app/components/timeline/timeline.component';
import { TimelineItemComponent } from 'src/app/components/timeline/timeline-item.component';
import { TimelineStartPipe } from 'src/app/services/pipes/timelineStart.pipe';
import { OnsiteSingleTimelineComponent } from './onsite.singletimeline.component';
import { traceNames } from 'src/app/services/performance.tracking.data';

@Component({
    selector: 'onsite-timeline',
    templateUrl: './onsite.timeline.html',
    styleUrls: ['./onsite.page.scss', './onsite.timeline.scss'],
    standalone: true,
    imports: [IconComponent, DatePipe, ExpandableBarWrapperComponent, MultiTimelineColumnComponent, TimelineItemComponent, TimelineStartPipe, OnsiteSingleTimelineComponent, CommonModule, MatMenuModule, LoaderPaneFragmentComponent],
})
export class OnsiteTimelineComponent extends Wrapper<OnsiteTimelineComponent> implements OnInit {

	detailedMode = true
	// timelineData: Observable<any>
	multiTimeline: DateSchedule[]
	singleTimeline: OnsiteSingleTimeline[]
	maxDateIndex = 0
	timelineMode
  currentEvent: JoiEvent = null
  labelMaps: LabelMaps = makeEmptyLabelMaps()
  filtersCount = 0
  performerDisplayTypes = performerDisplayTypes
  performers: { [pId: string]: Performer }
  sponsorTypes: { [tId:string]: Ranking }
  tagMap: Dictionary<TagPanelData> = {}
  performerRoles: Dictionary<Ranking>
  traceNames = traceNames;

  @Input() timelineViews
  @Input() mySchedule = false
	@Output() close: EventEmitter<null> = new EventEmitter();
	@Output() emitProgramDetail: EventEmitter<any> = new EventEmitter();
	@Output() emitBrickDetail: EventEmitter<any> = new EventEmitter();
  @Output() openFilters: EventEmitter<null> = new EventEmitter();

	ngOnInit() {

    this.subProp(this.store.select(this.mySchedule ? myScheduleFullMultiTimelineReeselector : fullMultiTimelineReselector), 'multiTimeline')
    this.subProp(this.store.select(this.mySchedule ? myScheduleFullSingleTimelineReselector : fullSingleTimelineReselector), 'singleTimeline')
    this.subProp(this.store.select(programSessionsActivitesMegaTagReselector), 'tagMap')
    this.subProp(this.store.select('onsite', this.mySchedule ? 'myTimelineMode' : 'timelineMode'), 'timelineMode')
    this.subProp(this.store.select('performers', 'entities'), 'performers')
    this.subProp(this.store.select('filters', 'onsiteTimeline', 'count'), 'filtersCount')
    this.subProp(this.store.select('sponsors', 'sponsorTypes'), 'sponsorTypes')

    this.subCallback(this.store.select('events'), ({ event, labelMaps }) => {
      this.currentEvent = event
      this.performerRoles = makeMapFromListOfObjectsAndKey(event?.performerRoles || [], 'id')
      this.labelMaps = labelMaps
    })

    const savedTimelineView = loadLocal(`${this.mySchedule ? 'mySchedule' : 'oss' }TimelineView`, 0) // 0 is returned if value is not in local storage
    if (savedTimelineView !== 0) {
      this.store.dispatch(onsiteActions.changeTimelineMode({ mode: savedTimelineView, myTimeline: this.mySchedule }))
    }


  }

  openProgram(event, programId) {
    if (event) event.stopPropagation()
    this.emitProgramDetail.emit({scheduleId:programId})
  }

  openProgramView({ event, scheduleId }) {
    // console.log({ event, scheduleId })
    this.openProgram(event, scheduleId )
  }


  trackBySingleTimeline(index, timeline: OnsiteSingleTimeline) {
    return timeline.dateId
  }

  trackByOnsiteProgram(index, program: OnsiteProgram) {
    return program.id
  }

  doPrint(){
    this.uiService.print();
  }

  toggleAll(action) {
    Object.keys(this.timelineViews).forEach(function (key) {
      this.timelineViews[key] = action;
    });
  }

	toggleView(newView: string) {
    console.log({ multiTimeline:this.multiTimeline, single:this.singleTimeline});
    this.store.dispatch(onsiteActions.changeTimelineMode({ mode: newView, myTimeline: this.mySchedule }))
    saveLocal(`${this.mySchedule ? 'mySchedule' : 'oss' }TimelineView`, newView)
	}

}
